import { onDomReady } from "../utils/on-dom-ready";

function getLanguageWithFallback() {
  return document.documentElement.lang
    ? document.documentElement.lang
    : "en-US";
}

function serializeToArray(formElement) {
  return [...new FormData(formElement).entries()].map(([name, value]) => ({
    name,
    value,
  }));
}

function buildResultItem(title, unit, label, description, iconSrc) {
  const resultItem = document.createElement("div");
  resultItem.className = "calculator__result_item";

  if (iconSrc) {
    const icon = document.createElement("img");
    icon.src = iconSrc;
    icon.alt = "";
    resultItem.append(icon);
  }

  const textWrapperElement = document.createElement("div");

  const titleElement = document.createElement("p");
  titleElement.className = "calculator__result_item__title";
  titleElement.innerHTML = `${title} ${unit}`;

  const labelWrapperElement = document.createElement("div");
  labelWrapperElement.className = description ? "has-tooltip" : "";

  const labelElement = document.createElement("span");
  labelElement.innerHTML = label;

  labelWrapperElement.append(labelElement);

  if (description) {
    const tooltipElement = document.createElement("div");
    tooltipElement.className = "calculator__result_item__tooltip";
    tooltipElement.dataset["toggle"] = "tooltip";
    tooltipElement.dataset["html"] = "true";
    tooltipElement.dataset["customClass"] = "calculator__tooltip";
    tooltipElement.dataset["placement"] = "top";
    tooltipElement.title = description;

    const tooltipIconElement = document
      .querySelector(".calculator__info-icon")
      .cloneNode(true);
    tooltipElement.append(tooltipIconElement);

    labelWrapperElement.append(tooltipElement);
  }

  textWrapperElement.append(titleElement);
  textWrapperElement.append(labelWrapperElement);

  resultItem.append(textWrapperElement);

  return resultItem;
}

function SanitizeInput(event) {
  const inputElement = event.currentTarget;

  const value = inputElement.value;
  const min = inputElement.dataset["minimum"];
  const max = inputElement.dataset["maximum"];

  if (value === "") {
    return;
  }

  let newValue = value.replace(/,/g, ".");
  newValue = newValue.replace(/[^-.\d]/g, "");
  if (newValue !== "") {
    newValue = parseFloat(newValue);

    if (max > min) {
      if (newValue < min) {
        newValue = min;
      }
      if (newValue > max) {
        newValue = max;
      }
    }
  }

  newValue = newValue.toString();

  if (newValue !== value) {
    inputElement.value = newValue;
  }
}

function ShowForm(calculator) {
  calculator.classList.add("show-calculator");
  calculator.classList.remove("show-results");
  calculator.classList.remove("show-loader");
  calculator.classList.remove("show-contact-form");
}

function ShowLoader(calculator) {
  calculator.classList.remove("show-calculator");
  calculator.classList.remove("show-results");
  calculator.classList.add("show-loader");
  calculator.classList.remove("show-contact-form");
}

function ShowResults(calculator, results) {
  calculator.classList.remove("show-calculator");
  calculator.classList.remove("show-loader");
  calculator.classList.remove("show-contact-form");
  calculator.classList.add("show-results");

  const listElement = calculator.querySelector(".calculator__results__list");
  listElement.innerHTML = "";

  results.forEach((result) => {
    listElement.append(
      buildResultItem(
        result.result,
        result.unit,
        result.label,
        result.description,
        result.icon
      )
    );
  });

  const hasTooltip = results.some((result) => result.description);

  window.setTimeout(() => {
    if (hasTooltip) {
      calculator.dispatchEvent(new Event("calculator:result"));
    }

    const carousels = calculator.querySelectorAll(".carousel");
    carousels.forEach((carousel) => {
      carousel.dispatchEvent(new Event("calculator.show.results"));
    });
  }, 100);
}

function DoCalculation(data, formula, digits) {
  let finalFormula = formula;

  data.forEach((field) => {
    const value = field.value === "" ? 0 : parseFloat(field.value);
    finalFormula = finalFormula.replace(field.name, value);
  });

  try {
    // eslint-disable-next-line no-eval
    const result = eval(finalFormula);
    return result.toLocaleString(getLanguageWithFallback(), {
      maximumFractionDigits: digits,
    });
  } catch {
    return false;
  }
}

function Calculate(calculator) {
  let formulas = calculator.dataset["formulas"];
  if (typeof formulas === "string") {
    formulas = JSON.parse(formulas);
  }

  const data = serializeToArray(
    calculator.querySelector(".calculator__form form")
  );

  const results = [];
  formulas.forEach((formula) => {
    const result = DoCalculation(data, formula.formula, formula.digits);

    if (result) {
      results.push({
        label: formula.label,
        icon: formula.icon,
        unit: formula.unit,
        description: formula.description,
        result,
      });
    }
  });

  ShowLoader(calculator);
  window.setTimeout(() => {
    ShowResults(calculator, results);
  }, 2000);
}

function ClearValues(calculator) {
  const calculatorForm = calculator.querySelector(".calculator__form form");

  calculatorForm.querySelectorAll("input,select").forEach((field) => {
    // eslint-disable-next-line no-param-reassign
    field.value = field.dataset["default"];
  });
}

function ShowContactForm(calculator) {
  calculator.classList.remove("show-results");
  calculator.classList.remove("show-loader");
  calculator.classList.add("show-contact-form");
}

function OnButtonClick(event, calculatorElement) {
  event.preventDefault();
  const behavior = event.currentTarget.dataset["behavior"];

  switch (behavior) {
    case "back":
      ShowForm(calculatorElement);
      break;
    case "clear":
      ClearValues(calculatorElement);
      break;
    case "calculate":
      Calculate(calculatorElement);
      break;
    case "contactForm":
      ShowContactForm(calculatorElement);
      break;
    default:
      break;
  }
}

function InitCalculator() {
  document.querySelectorAll(".calculator").forEach((calculatorElement) => {
    ClearValues(calculatorElement);

    const calculatorForm = calculatorElement.querySelector(
      ".calculator__form form"
    );

    const inputElements = calculatorForm.querySelectorAll("input");
    inputElements.forEach((inputElement) => {
      inputElement.addEventListener("change", SanitizeInput);
    });

    const buttonElements = calculatorElement.querySelectorAll(
      ".calculator__button"
    );
    buttonElements.forEach((buttonElement) => {
      buttonElement.addEventListener("click", (event) => {
        OnButtonClick(event, calculatorElement);
      });
    });

    InitContactForm(calculatorElement);
  });
}

function InitContactForm(calculator) {
  const contactForm = calculator.querySelector(".calculator__contact-form");

  const instanceId = contactForm.dataset["instanceId"];

  contactForm.addEventListener("formdata", (event) => {
    const formData = event.formData;

    const calculatorFieldElements = calculator.querySelectorAll(
      ".calculator__form .calculator__field"
    );

    const calculatorFields = [];

    calculatorFieldElements.forEach((field) => {
      const label =
        field.querySelector(".calculator__field__label").innerText ?? "";
      const value =
        field.querySelector(".calculator__field__field input").value ?? "";

      calculatorFields.push({
        label,
        value,
      });
    });

    formData.append(
      `tx_jhcalculator_calculator[${instanceId}][co2CalculatorInputs]`,
      JSON.stringify(calculatorFields)
    );
  });
}

onDomReady(InitCalculator);
